import React, {useState} from "react";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
} from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLink } from '@fortawesome/free-solid-svg-icons';

const Leadership = () => {
  document.documentElement.classList.remove("nav-open");

  const customCardCategoryStyle = {
    color: '#f1f1f1', // Define the color you want here
  };

  const teamMembers = [
    {
      name: 'Ian Randall',
      linkedinLink: 'https://www.linkedin.com/in/ian-randall-a74695156/',
      imgSrc: require("assets/img/leadership/ian.jpg"),
      title: 'Co-Founder, President, CEO',
      description: 'Ian is an experienced engineer and innovator with a background in Aeronautical and Electrical Engineering from Purdue University. He has lead engineering teams in robotics, drones, and electrified vehicles which lead to the technical expertise and orientation that sparked MagLev Aero’s radical approach to Urban Air Mobility. He has over 32 issued patents internationally. ',
    },
    {
      name: 'Rod Randall',
      linkedinLink: 'https://www.linkedin.com/in/rodrandall/',
      imgSrc: require("assets/img/leadership/rod.webp"),
      title: 'Co-Founder, Chairman',
      description: 'Rod is a highly accomplished tech entrepreneur, senior executive, venture capitalist, and private equity executive partner, with over 25 years of experience in the wireless, telecommunications, computer-networking, and electric vehicle industries. He currently serves on the boards of Fisker Inc. (NYSE: FSR), Mavenir Systems Inc., and Vaughn College of Aeronautics and Technology. ',
    },
    {
      name: 'Phillip Gomez',
      linkedinLink: 'https://www.linkedin.com/in/phillip-gomez-a4b2b466/',
      imgSrc: require("assets/img/leadership/phil.png"),
      title: 'VP of Product and Defense Systems',
      description: 'Phillip Gomez brings over 15 years of experience across rotorcraft, advanced lift systems, and propulsion programs, supporting defense and commercial aerospace platforms. His background includes JMR-FVL / FLRAA from inception through PoR, along with defense programs across DARPA, the U.S. Army, U.S. Air Force, and NASA, with a focus on advanced propulsion, aeromechanics, and system integration. ',
    },
    {
      name: 'Bernardo Concia',
      linkedinLink: 'https://www.linkedin.com/in/bconcia/',
      imgSrc: require("assets/img/leadership/bern.png"),
      title: 'Director of Engineering',
      description: 'Bernardo is an Aerospace Engineer from Argentina who moved to the U.S. under a Fulbright-administered scholarship to earn a Master’s in Electrical Engineering. His expertise spans control and dynamics, system architecture, and embedded software. During his six years at Maglev Aero, he has architected the company’s core technology, most notably developing a patented "Individual Blade Pitch Control" system for a electrodynamically suspended rotor.',
    },
    {
      name: 'Torbjörn Lembke',
      linkedinLink: 'https://www.linkedin.com/in/torbj%C3%B6rn-lembke-a469753a/',
      imgSrc: require("assets/img/leadership/torbjorn.jpg"),
      title: 'Chief Maglev Scientist',
      description: 'Torbjörn is an influential leader in the field of electromechanical engineering with a distinguished career pursuing unprecedented magnetic innovations. Prior to joining MagLev, Torbjörn served as a lead for Magnetic Levitation at Hyperloop Transportation Technologies. ',
    },
    {
      name: 'Kristen Bates',
      linkedinLink: 'https://www.linkedin.com/in/kristenjbates/',
      imgSrc: require("assets/img/leadership/kristen.webp"),
      title: 'Head of HR',
      description: 'Kristen is an internationally-experienced human resource professional and entrepreneur with a diverse career spanning over 20 years supporting various tech start-ups; building teams in EV, aerospace, and battery materials industries. ',
    },
  ];

  const handleLinkedInClick = (linkedinProfileUrl) => {
    window.open(linkedinProfileUrl, '_blank');
  };

  return (
    <>
      <div className="main">
        <div className="section section-maglev-blue-dark text-center">
          <Container>
            <h2 className="title" style={{fontWeight: 'bolder'}}>Leadership</h2>
            <Row className="justify-content-center">
            {teamMembers.map((member, index) => (
              <Col md="4" key={index}>
                <Card className="card-profile card-plain">
                  <div className="card-avatar">
                    <a href={member.linkedinLink} data-toggle="tooltip" data-placement="top" target="_blank" rel="noopener noreferrer" title={`Check out ${member.name} on LinkedIn`}>
                      <img alt="..." src={member.imgSrc} />
                    </a>
                  </div>
                  <CardBody>
                    <a href="#person" onClick={(e) => e.preventDefault()}>
                      <div className="author">
                        <CardTitle tag="h3">{member.name}</CardTitle>
                        <h4 className="card-category" style={customCardCategoryStyle}>{member.title}</h4>
                      </div>
                    </a>
                    <p className="card-description text-center">
                      {member.description}
                    </p>
                    <br/>
                    <Button
                      onClick={() => handleLinkedInClick(member.linkedinLink)}
                      className="btn-round mr-1"
                      color="neutral"
                      outline
                    >
                      Learn more&nbsp;&nbsp;<FontAwesomeIcon icon={faExternalLink}/>
                    </Button>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
          </Container>
        </div>
        </div>
    </>
  );
}

export default Leadership;
